import * as React from 'react'

const SvgComponent = props => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 19.8 18.89' {...props}>
    <path d='M6.57 8.31c-.7 0-1.28-.56-1.28-1.27v-.02c0-.72.57-1.29 1.28-1.29s1.28.57 1.28 1.29S7.28 8.3 6.57 8.3Zm6.67 0c-.7 0-1.28-.56-1.28-1.27v-.02c0-.72.57-1.29 1.28-1.29s1.28.57 1.28 1.29-.57 1.28-1.28 1.28Zm-8.51 7.7.72-.44c.81-.49 1.77-.68 2.7-.54.21.03.39.06.52.08.41.05.82.08 1.24.08 4.42 0 7.9-3.02 7.9-6.6s-3.48-6.6-7.9-6.6S2 5.02 2 8.6c0 1.37.5 2.67 1.43 3.78.05.06.12.14.21.23.8.83 1.2 1.96 1.1 3.1l-.03.3Zm-.63 2.73a1.003 1.003 0 0 1-1.53-.93l.19-2.26c.05-.57-.15-1.14-.55-1.55-.1-.11-.21-.22-.3-.33C.72 12.25.01 10.5.01 8.6 0 3.85 4.43 0 9.9 0s9.9 3.85 9.9 8.6-4.43 8.6-9.9 8.6c-.51 0-1.01-.03-1.5-.1-.19-.03-.38-.05-.57-.08-.47-.07-.95.02-1.35.27l-2.39 1.46Z' />
  </svg>
)

export default SvgComponent
